import r2rServicesClient from 'common/utils/r2rServicesClient'
import { geocodeEndpoint } from 'common/utils/paths'

// Related to rome2rio.web\Scripts\GeoCoderResult.js
class GeocoderResult {

  constructor(result) {
    this.longName = result.longName
    this.shortName = result.shortName
    this.canonicalName = result.canonicalName
    this.countryCode = result.countryCode
    this.kind = result.kind
    this.latlng = {
      lat: result.lat,
      lng: result.lng,
    }
    this.special = (result.isSpecial != 0)
    this.radius = result.rad
    this.googlePlaceId = result.googlePlaceId
  }

  isSpecial = () => {
    return !!this.special
  }

  // output of this function must match with the output
  // of Serialize() in rome2rio.web\Scripts\GeoCoderResult.js
  // because it's what's saved in previousOrigin and previousDestination cookies
  serialize = () => {
    return JSON.stringify(this)
  }

  static getGeocoderResult(longName, languageCode) {
    const geocodeConfig = {
      params: {
        key: '86f5qBa1',
        query: longName,
        languageCode,
      },
      sendAnalyticsIds: false,
    }

    return new Promise((resolve, reject) => {
      r2rServicesClient.get(geocodeEndpoint, geocodeConfig)
        .then(response => {
          if (!response.data.places.length || !response.data.places[0]) {
            reject()
            return
          }

          const place = response.data.places[0]
          const geocoderResult = new GeocoderResult(place)

          resolve(geocoderResult)
        })
    })
  }
}

export default GeocoderResult

